module.exports = __webpack_public_path__ + "static/media/pra-hot-users.0438a036.png";